module.exports = __webpack_public_path__ + "static/fonts/icomoon.8512a2ae.ttf";